import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20illustration%2C%20warm%20golden%20amber%20gradient%20background%20with%20subtle%20comic%20panel%20borders%2C%20soft%20abstract%20textures%2C%20elegant%20minimal%20style%2C%20storytelling%20atmosphere%2C%20no%20text&width=1600&height=600&seq=hanman-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-primary-900/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
          准备好开启你的韩漫之旅了吗？
        </h2>
        <p className="text-base md:text-lg text-background-100/70 mb-8 max-w-xl mx-auto leading-relaxed">
          每天都有新章节更新，随时随地享受韩国漫画免费看的乐趣。
          加入50万+读者，一起体验最精彩的韩漫在线阅读！
        </p>
        <Link
          to="/"
          className="inline-block px-8 py-3 rounded-full bg-accent-500 text-background-50 font-medium text-base hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          立即免费阅读
        </Link>
      </div>
    </section>
  );
}